export const MORE_THEN_THREE_MONTHS_KEY = "si.common.more_then_two_months";
export const TODAY_KEY = "si.common.today";
export const NUMBER_DAYS_AGO_KEY = "si.lead_gen_filters.sl.days_ago";
export const UPDATED_KEY = "si.common.updated";
